<template>
    <div class="documentation">
        <Breadcumb title="Ajouter un article" :breadcumb-data="breadcumbData"></Breadcumb>
        <b-form @submit="addForumArticle" class="cardcontainer" id="docform">
                    <b-card class="mb-3 pb-3">
                        <b-form-group label="Titre de l'article" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                            <b-input type="text" placeholder="Titre" v-model="title" :state="errors.title ? 'invalid': ''"/>
                            <div v-if="errors['title']" class="invalid-tooltip">{{ errors['title'][0] }}</div>
                        </b-form-group>
                        <b-form-group label="Article en français" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                            <quill-editor
                                    v-model="article"
                                    :options="editorOption"
                                    @change="onEditorChange($event)"
                                    style="height:500px;"
                            />
                        </b-form-group>
                    </b-card>
                <!-- Buttons -->
                <b-btn variant="primary" slot="finish" @click="addForumArticle">Ajouter</b-btn>
        </b-form>
    </div>
</template>
<script>
    import Breadcumb from '../components/breadcumb';
    import {ADD_FORUMARTICLE_REQUEST} from "../_store/exchange/actiontypes";

    export default {
        name: 'adminDocumentationAdd',
        components: { Breadcumb, },
        mounted() {
        },
        data() {
            return ({
                breadcumbData: [
                    { text: 'Accueil', href: '/dashboard/' },
                    { text: 'Forum', href: '/echange/forum/' },
                    { text: 'Ajouter un article', active: true },
                ],
                article: '',
                title: '',
                errors: [],
                editorOption: {
                    // Some Quill options...
                }
            });
        },
        layout(context) {
            return 'layout';
        },
        methods: {
            addForumArticle: function (e) {
                e.preventDefault();
                this.$store.dispatch(ADD_FORUMARTICLE_REQUEST, {
                    title: this.title,
                    content: this.article,
                    category: this.$route.params.id
                })
                    .then(() => {
                        this.$router.push('/echanges/forum/' + this.$route.params.id + '/');
                    })
                
            }
        },
    };
</script>
